@if (campaignModalData.properties.steps.length === 1) {
  <div
    class="c-campaignModal"
    [class.c-campaignModal--fullScreen]="campaignModalData.fullScreen">
    @if (campaignModalData.properties.steps[0].closeable) {
      <slotcom-navigation-button
        type="close"
        (click)="closeModal()">
      </slotcom-navigation-button>
    }

    <div class="c-campaignModal__body">
      <div
        class="c-campaignModal_background"
        [ngStyle]="{
          'background-image': 'url(' + campaignModalData.properties.steps[0].imageUrl + ')'
        }"></div>

      <div class="c-campaignModal__button">
        <slotcom-button
          class="c-button--pink"
          (safeClick)="closeModalByAction(campaignModalData.properties.actionUrl)"
          audioType="functionality">
          {{
            campaignModalData.properties.steps[0].buttonText
              ? campaignModalData.properties.steps[0].buttonText
              : ('home.buttons.got-it' | translate | uppercase)
          }}
        </slotcom-button>
      </div>
    </div>
  </div>
} @else {
  <slotcom-wizard-modal [wizardModalData]="wizardModalData"></slotcom-wizard-modal>
}
